<template>
  <div class="chores-body">
    <loader :isShow="isLoading && hasLoaded" :textInfo="''" />
    <div class="chores-top-container">
      <div class="chores-title">Chores</div>
      <div class="chores-menu-container">
        <v-popover offset="16" :auto-hide="true" placement="bottom-start">
          <button class="task-cards-filter">
            <span>Properties</span>
            <img class="down-arrow" src="@/assets/DownGreyArrow.svg" />
          </button>
          <template slot="popover">
            <generic-search-check-box-menu
              @property-checked="filterByProperties"
              :checked="selProperties"
              displayProperty="internalName"
              :things="properties"
              class="task-calendar-filter-container"
              searchThing="property"
              :key="'calendar-property-filter'"
            />
          </template>
        </v-popover>
        <v-popover offset="16" :auto-hide="true" placement="bottom-start">
          <button class="task-cards-filter">
            <span>Chores</span>
            <img class="down-arrow" src="@/assets/DownGreyArrow.svg" />
          </button>
          <template slot="popover">
            <generic-search-check-box-menu
              @chore-checked="filterByChores"
              :checked="selChores"
              displayProperty="name"
              :things="propChores"
              class="task-calendar-filter-container"
              searchThing="chore"
              :key="'calendar-chore-filter'"
            />
          </template>
        </v-popover>
        <button
          class="chores-new-assignment-button"
          @click="toggleAssignmentMenu(null)"
        >
          <span> Assign Chore </span>
        </button>
        <button class="chores-new-chore-button" @click="toggleMenu()">
          <span id="chores-new-chore-router-link"> New Chore </span>
        </button>
      </div>
    </div>

    <div v-if="isInitialLoading" class="chores-loading">
      <chores-skeleton />
    </div>

    <div
      v-if="!isInitialLoading"
      class="chores-bottom-container"
      :key="choresListKey"
    >
      <ChoreCell
        v-for="chore of this.filteredChores"
        :key="chore.uuid"
        :chore="chore"
        :readOnly="false"
        @cancel="toggleMenu()"
        @edit="editTask"
        @delete="reload"
        @edit-assignment="toggleEditAssignment"
        @delete-assignment="deleteAssignment"
        @assign="toggleAssignmentMenu"
      />
    </div>

    <div v-if="showMenu">
      <new-chore-menu
        :selTask="selTask"
        @cancel="toggleMenu()"
        @save-create="reload"
        @loading="isLoading = $event"
      />
    </div>

    <div v-if="showEditAssignmentMenu">
      <edit-assignment-menu
        :selAssignment="selAssignment"
        @cancel="toggleEditAssignment"
        @saved="assignmentEdited"
        :allHousemates="allHousemates"
        @loading="isLoading = $event"
      />
    </div>

    <div v-if="showAssignmentMenu">
      <chore-assignment-menu
        @create="assignmentCreated"
        @cancel="toggleAssignmentMenu"
        :chores="chores"
        :inputChore="selChore"
        :inputProperty="referencedProperty"
        :assignment="selAssignment"
        @loading="isLoading = $event"
      />
    </div>

    <section class="empty-chores-screen" v-if="showEmptyState">
      <img src="../../assets/chores_empty_icon.svg" />
      <div>Add your first chore</div>
      <button @click="toggleMenu()">New Chore</button>
    </section>

    <section class="empty-chores-screen" v-if="showNoFilterResults">
      <img src="../../assets/no_filtered_chores.svg" />
      <div class="no-result">No results found</div>
      <div>We couldn’t find the chore you are looking for</div>
    </section>
  </div>
</template>

<script>
import ChoreCell from '@/components/tasks/ChoreCell.vue'
import calls from '@/api/calls'
import NewChoreMenu from '@/components/tasks/NewChoreMenu.vue'
import EditAssignmentMenu from '@/components/tasks/EditAssignmentMenu.vue'
import ChoreAssignmentMenu from '../../components/tasks/ChoreAssignmentMenu.vue'
import GenericSearchCheckBoxMenu from '@/components/GenericSearchCheckBoxMenu'
import Loader from '@/components/Loader.vue'
import ChoresSkeleton from '@/components/shared/ChoresSkeleton.vue'

export default {
  name: 'MyChoresScreen',
  components: {
    ChoreCell,
    NewChoreMenu,
    EditAssignmentMenu,
    ChoreAssignmentMenu,
    GenericSearchCheckBoxMenu,
    Loader,
    ChoresSkeleton
  },
  data() {
    return {
      chores: [],
      propChores: [],
      properties: [],
      selTask: null,
      selPropperty: {},
      selAssignment: null,
      showMenu: false,
      showDeleteMenu: false,
      showEditAssignmentMenu: false,
      showAssignmentMenu: false,
      allHousemates: [],
      propertiesFilterSelected: false,
      choresFilterSelected: false,
      mouseCoordsProperties: null,
      mouseCoordsChores: null,
      selProperties: [],
      selChores: [],
      selChore: null, //the chore from the chore card that you are assigning
      referencedProperty: null, //the propertie from which this chore belongs to ^
      choresListKey: 0,
      isLoading: true,
      hasLoaded: false
    }
  },
  computed: {
    filteredChores() {
      const filtered = []
      const ids = []
      for (let chore of this.chores) {
        if (
          this.selProperties.length > 0 &&
          !this.selProperties.includes(chore.propertyUuid)
        )
          continue
        if (this.selChores.length > 0 && !this.selChores.includes(chore.uuid))
          continue
        if (ids.includes(chore.uuid)) continue
        filtered.push(chore)
        ids.push(chore.uuid)
      }
      return filtered
    },
    noChores() {
      return this.chores.length === 0
    },
    isInitialLoading() {
      return this.isLoading && !this.hasLoaded
    },
    showEmptyState() {
      return this.hasLoaded && !this.isLoading && this.noChores
    },
    showNoFilterResults() {
      return (
        this.hasLoaded &&
        !this.isLoading &&
        !this.noChores &&
        this.filteredChores.length === 0
      )
    }
  },
  methods: {
    filterByProperties(id) {
      if (this.selProperties.includes(id)) {
        const index = this.selProperties.indexOf(id)
        this.selProperties.splice(index, 1)
      } else {
        this.selProperties.push(id)
      }

      // Filter chores based on selected properties
      let filtChor = []
      for (let i = 0; i < this.chores.length; i++) {
        if (this.selProperties.includes(this.chores[i].propertyId))
          filtChor.push(this.chores[i])
      }

      if (this.selProperties.length == 0) this.propChores = this.chores
      else this.propChores = filtChor

      // Leave selected chores if they match property
      let ids = []
      for (let i = 0; i < this.propChores.length; i++)
        ids.push(this.propChores[i].uuid)

      for (let i = this.selChores.length; i >= 0; i--) {
        let id = this.selChores[i]
        if (!ids.includes(id)) {
          this.selChores.splice(i, 1)
        }
      }
    },
    filterByChores(id) {
      if (this.selChores.includes(id)) {
        const index = this.selChores.indexOf(id)
        this.selChores.splice(index, 1)
      } else {
        this.selChores.push(id)
      }
    },
    styleFilterProperties() {
      return {
        left: this.mouseCoordsProperties.x + 'px',
        top: this.mouseCoordsProperties.y + 48 + 'px'
      }
    },
    styleFilterChores() {
      return {
        left: this.mouseCoordsChores.x - 120 + 'px', //this is the containers with + padding
        top: this.mouseCoordsChores.y + 48 + 'px' //magic value
      }
    },
    choresFilterClicked() {
      this.choresFilterSelected = !this.choresFilterSelected
      const el = this.$refs['task-cards-chore-filter']
      this.mouseCoordsChores = {
        x: el.getBoundingClientRect().x + 125,
        y: el.getBoundingClientRect().y
      }
    },
    propertiesFilterClicked() {
      this.propertiesFilterSelected = !this.propertiesFilterSelected
      const el = this.$refs['task-cards-property-filter']
      this.mouseCoordsProperties = {
        x: el.getBoundingClientRect().x - 125,
        y: el.getBoundingClientRect().y
      }
    },
    async assignmentCreated() {
      this.showAssignmentMenu = false
      await this.reload()
    },
    async assignmentEdited() {
      this.showEditAssignmentMenu = false
      await this.reload()
    },
    async toggleAssignmentMenu(selChore) {
      const willOpen = !this.showAssignmentMenu
      if (willOpen) {
        this.isLoading = true
        try {
          if (selChore != null) {
            this.selChore = selChore
            const { data } = await calls.GET(
              'chores/property/from',
              selChore.uuid
            )
            this.referencedProperty = data
          }
          this.showAssignmentMenu = true
        } catch {
          this.isLoading = false
        }
        return
      }
      this.showAssignmentMenu = false
      this.isLoading = false
      this.selChore = null
      this.referencedProperty = null
    },
    async deleteAssignment(assignment) {
      const { message, data } = await calls.DELETE(
        `assignment/${assignment.uuid}`
      )
      await this.reload()
    },
    toggleEditAssignment(assignment) {
      this.selAssignment = assignment
      this.showEditAssignmentMenu = assignment ? true : false
      if (!assignment) {
        this.isLoading = false
      }
    },
    async reload() {
      this.showDeleteMenu = false
      this.showMenu = false
      this.showEditAssignmentMenu = false
      this.isLoading = true
      try {
        await this.loadData()
      } finally {
        this.isLoading = false
      }
      this.choresListKey += 1
    },
    async editTask(task) {
      this.selTask = task
      this.toggleMenu()
    },
    toggleMenu() {
      this.showMenu = !this.showMenu
      if (!this.showMenu) {
        this.selTask = null
        this.isLoading = false
      }
    },
    toggleDeleteMenu() {
      this.showDeleteMenu = !this.showDeleteMenu
      if (!this.showDeleteMenu) this.selTask = null
    },
    async loadData() {
      {
        const { data, message } = await calls.GET('properties')
        this.properties = data
      }
      {
        const { data, message } = await calls.GET('chores')
        const promises = []
        for (const chore of data)
          promises.push(calls.GET('chores/property/from', chore.uuid))
        const results = await Promise.all(promises)
        for (const index in results) {
          const property = results[index].data
          if (property == null) continue
          data[index].propertyInternalName = property.internalName
          data[index].propertyUuid = property.uuid
        }
        this.chores = data
        this.propChores = data
      }
      {
        const { data, message } = await calls.GET('housemates')
        this.allHousemates = data
      }
    }
  },
  async beforeMount() {
    this.isLoading = true
    try {
      await this.loadData()
    } finally {
      this.hasLoaded = true
      this.isLoading = false
    }
  }
}
</script>

<style scoped>
#propButton {
  width: 120px;
  height: 48px;
  border-radius: 4px;
  border: solid 1px #cbd4dc;
  background-color: #ffffff;
  color: #767675;
  font-size: 14px;
  border: none;
  margin-right: 10px;
}
.chores-body {
  padding: 24px 24px 0 24px;
  background-color: #f5f6f8;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.chores-top-container {
  width: 100%;
  height: 40px;
  margin-left: 10px; /* to match up with the cards */
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}

.chores-loading {
  padding: 0;
  margin-top: 25px;
  width: 100%;
}

.chores-bottom-container {
  padding: 0;
  margin-top: 25px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  flex-wrap: wrap;
  gap: 16px;
}

.chores-title {
  font-family: Montserrat;
  font-size: 28px;
  font-style: normal;
  font-weight: 900;
  line-height: 40px;
  letter-spacing: 1px;
  text-align: left;
  color: #000000;
}

.chores-menu-container {
  width: 650px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}

.chores-select-property-dropdown,
.chores-select-chore-dropdown,
.chores-new-assignment-button,
.chores-new-chore-button {
  height: 100%;
}

.chores-new-assignment-button,
.chores-new-chore-button {
  width: 160px;
}

.chores-select-chore-dropdown,
.chores-select-property-dropdown {
  cursor: pointer;
  width: 130px;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: center;
  color: #767675;
  border: 1px solid #cbd4dc;
  border-radius: 4px;
}

.chores-new-assignment-button {
  cursor: pointer;
  background: #ebf0e6;
  border: 1px solid var(--rentalios-dark);
  border-radius: 4px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 850;
  font-size: 14px;
  color: var(--rentalios-dark);
  height: 40px;
}

.chores-new-chore-button {
  cursor: pointer;
  background-color: #66b015;
  border: 1px solid #66b015;
  border-radius: 4px;
  height: 40px;
}
#chores-new-chore-router-link {
  color: #ffffff;
  font-weight: 900;
}

.cellContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}

.task-cards-filter {
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #cbd4dc;
  box-sizing: border-box;
  border-radius: 4px;
  width: 120px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  align-items: center;
  color: #767675;
  padding-left: 16px;
}

.task-cards-filter.selected {
  background: #ffffff;
  border: 1px solid #66b015;
  color: #66b015;
}

.empty-chores-screen {
  width: 100%;
  padding-top: 10%;
  height: 90%;
}
.empty-chores-screen img {
  width: 50%;
  height: 50%;
}

.empty-chores-screen div {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 40px;
}

.empty-chores-screen button {
  border: none;
  background: #66b015;
  border-radius: 4px;
  width: 192px;
  height: 40px;
  color: white;
  font-family: Montserrat;
  font-size: 16px;
}

.no-result {
  font-weight: 900 !important;
}

.task-calendar-filter-container {
  position: absolute;
}

@media (max-width: 1100px) {
  .chores-title {
    width: 100%;
    height: auto;
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 8px;
  }
  .chores-top-container {
    flex-direction: column;
    gap: 16px;
    margin-bottom: 20px;
    height: auto;
    width: unset;
    margin-right: 24px;
  }
  .chores-menu-container {
    flex-direction: column;
    width: 100%;
    gap: 16px;
  }
  ::v-deep .trigger {
    width: 100%;
  }
  .task-cards-filter {
    width: 100%;
    height: 44px;
    font-size: 16px;
  }
  .chores-new-assignment-button,
  .chores-new-chore-button {
    width: calc(100% + 9px);
    height: 44px;
    font-size: 16px;
  }
  ::v-deep .chore-assignment-selector-container {
    flex-direction: column;
  }
  ::v-deep .chore-assignment-container {
    width: fit-content;
    left: 20%;
  }

  /* Enhanced mobile scrolling */
  .chores-body {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    height: 100vh;
  }

  .chores-bottom-container {
    overflow: visible;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center;
  }
}
@media (max-width: 480px) {
  .chores-title {
    font-size: 18px;
    line-height: 24px;
  }
  ::v-deep .chore-assignment-container {
    width: fit-content;
    left: 10%;
    max-width: 250px;
  }

  /* Additional mobile optimizations */
  .chores-body {
    padding: 16px 16px 0 16px;
  }

  .chores-top-container {
    margin-left: 0;
    margin-right: 16px;
  }

  .chores-menu-container {
    gap: 12px;
  }

  .task-cards-filter {
    height: 44px;
    font-size: 16px;
  }

  .chores-new-assignment-button,
  .chores-new-chore-button {
    height: 44px;
    font-size: 16px;
  }

  .chores-bottom-container {
    margin-top: 20px;
    padding: 0 8px;
  }

  .empty-chores-screen {
    padding-top: 20%;
    height: 80%;
    text-align: center;
  }

  .empty-chores-screen img {
    width: 40%;
    height: auto;
    margin-bottom: 16px;
  }

  .empty-chores-screen div {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 8px;
  }

  .empty-chores-screen button {
    width: 100%;
    max-width: 200px;
    height: 44px;
    font-size: 16px;
  }
}
</style>
